import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
  tone?: "light" | "dark";
}

export default function Breadcrumb({ items, tone = "light" }: BreadcrumbProps) {
  const isDark = tone === "dark";
  const linkClass = isDark
    ? "text-secondary-100/70 hover:text-accent-300"
    : "text-foreground-500 hover:text-primary-600";
  const currentClass = isDark ? "text-secondary-50" : "text-foreground-800";
  const sepClass = isDark ? "text-secondary-100/40" : "text-foreground-300";

  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs">
      <Link to="/" className={`flex items-center gap-1 transition-colors duration-200 ${linkClass}`}>
        <span className="flex h-3.5 w-3.5 items-center justify-center">
          <i className="ri-home-4-line text-[13px]"></i>
        </span>
        首页
      </Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-2">
          <span className={`flex h-3.5 w-3.5 items-center justify-center ${sepClass}`}>
            <i className="ri-arrow-right-s-line text-[13px]"></i>
          </span>
          {item.path ? (
            <Link to={item.path} className={`transition-colors duration-200 ${linkClass}`}>
              {item.label}
            </Link>
          ) : (
            <span className={`max-w-[220px] truncate sm:max-w-none ${currentClass}`}>
              {item.label}
            </span>
          )}
        </span>
      ))}
    </nav>
  );
}